import { Department } from "@app/models/User";
import { getRequest } from "@app/services/api/api";

export const useDepartmentService = () => {
  const fetchDepartment = async () => {
    return await getRequest<Department[]>(`/departments`);
  };

  return {
    fetchDepartment,
  };
};
